'use client';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { VStack, InputGroup, InputRightElement } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';
import LabelText from 'shared/InputsLabelText';
import ErrorText from 'shared/InputsErrorText';
import CountrySelector from './CountrySelector';
import PhoneMaskedInput from './PhoneMaskedInput';

import { phoneInputWrapperStyle } from 'constants/inputsWrappersStyles';
import Cross from 'assets/icons/cross.svg';
import '../style.css';

const PhoneField = ({
  label = '',
  hint = '',
  error = false,
  onChange,
  value,
  max = undefined,
  maxH = null,
  minH = null,
  inputRef,
  trigger = null,
  ...props
}) => {
  const input = useRef(null);
  const [activeMask, setActiveMask] = useState(0);

  const setRefs = useCallback(
    node => {
      input.current = node;
      inputRef(node);
    },
    [inputRef],
  );

  const handleFocusInput = useCallback(() => input.current.element?.focus(), []);
  const handleClear = useCallback(() => onChange(''), [onChange]);
  const handleMaskChange = useCallback(
    i => {
      handleClear();
      setActiveMask(i);
    },
    [handleClear],
  );

  useEffect(() => {
    return () => trigger && trigger(props.name);
  }, [props.name, trigger]);

  const isPhoneEntered = value?.length && !['+7', '+375'].includes(value);

  return (
    <VStack w="full" align="start" gap="0" position="relative">
      <LabelText value={value} label={label} zIndex="30" />

      <InputGroup role="group" sx={phoneInputWrapperStyle(error)} onClick={handleFocusInput}>
        <CountrySelector activeMask={activeMask} onMaskChange={handleMaskChange} />

        <PhoneMaskedInput
          inputRef={setRefs}
          value={value}
          activeMask={activeMask}
          onChange={onChange}
          handleClear={handleClear}
          {...props}
        />

        <InputRightElement
          boxSize="16px"
          pos="relative"
          opacity={isPhoneEntered ? 1 : 0}
          pointerEvents={isPhoneEntered ? 'all' : 'none'}
          onClick={handleClear}
        >
          <NextImage src={Cross} alt="Крестик" w="auto" h="auto" />
        </InputRightElement>
      </InputGroup>

      <ErrorText error={error} hint={hint} />
    </VStack>
  );
};

export default memo(PhoneField);
